import { TAXDOWN_ASSETS_DOMAIN } from './domains';

export type iconsPath = {
  [key: string]: string;
};
export const iconsPaths: iconsPath = {
  ETORO: `${TAXDOWN_ASSETS_DOMAIN}/mx/EtoroIcon.svg`,
  ABANCA: `${TAXDOWN_ASSETS_DOMAIN}/mx/AbancaIcon.svg`,
  BNEXT: `${TAXDOWN_ASSETS_DOMAIN}/mx/BnextIcon.svg`,
  FINTONIC: `${TAXDOWN_ASSETS_DOMAIN}/mx/FintonicIcon.svg`,
  GOIN: `${TAXDOWN_ASSETS_DOMAIN}/mx/GoinIcon.svg`,
  JOB: `${TAXDOWN_ASSETS_DOMAIN}/mx/JobIcon.svg`,
  OPEN: `${TAXDOWN_ASSETS_DOMAIN}/mx/OpenIcon.svg`,
  RELALE: `${TAXDOWN_ASSETS_DOMAIN}/mx/RelaleIcon.svg`,
  SODEXO: `${TAXDOWN_ASSETS_DOMAIN}/mx/SodexoIcon.svg`,
  VERTIL: `${TAXDOWN_ASSETS_DOMAIN}/mx/VertilIcon.svg`,
  PREVIOUS_YEARS: `${TAXDOWN_ASSETS_DOMAIN}/mx/previousYears.svg`,
  PREVIOUS_YEARS_IN_PROGRESS: `${TAXDOWN_ASSETS_DOMAIN}/mx/workInProgress.svg`,
  PREVIOUS_YEARS_IN_ANALAYTICS: `${TAXDOWN_ASSETS_DOMAIN}/mx/continueAnalytics.svg`,
  TAXITO: `${TAXDOWN_ASSETS_DOMAIN}/mx/taxito.svg`,
  TAX: `${TAXDOWN_ASSETS_DOMAIN}/mx/tax.svg`,
};

export const brandsIconsData = [
  {
    id: 1,
    url: iconsPaths.GOIN,
  },
  {
    id: 2,
    url: iconsPaths.FINTONIC,
  },
  {
    id: 3,
    url: iconsPaths.ETORO,
  },
  {
    id: 4,
    url: iconsPaths.VERTIL,
  },
  {
    id: 5,
    url: iconsPaths.RELALE,
  },
  {
    id: 6,
    url: iconsPaths.BNEXT,
  },
  {
    id: 7,
    url: iconsPaths.OPEN,
  },
  {
    id: 8,
    url: iconsPaths.JOB,
  },
  {
    id: 9,
    url: iconsPaths.ABANCA,
  },
];
